export const numericIdFn = (route) => {
  return {
    id: parseInt(route.params.id, 10)
  }
}

export const numericIdStudentIdFn = (route) => {
  return {
    id: parseInt(route.params.id, 10),
    studentId: parseInt(route.params.studentId, 10),
  }
}
